<template>

    <div>
      <h1>Single PPanel Export</h1>
      <pd-uploadfileblock :data-obj="singlePpanelFiles" data-id="singlePpanelFiles" :clickFn="addSingle"></pd-uploadfileblock>

      <h1>Full PPanel Export</h1>
      <pd-uploadfileblock :data-obj="fullPpanelFiles" data-id="fullPpanelFiles" :clickFn="addGlobal"></pd-uploadfileblock>

        <div class="buttonbar">
            <pd-button label="Save" :click="save"></pd-button>
        </div>
    </div>

</template>


<script>
    import {mapGetters, mapState} from 'vuex';
    import Button from "../components/button.vue";
    import Uploadfileblock from "../components/uploadfileblock.vue";


    export default {
        name: 'exportConfigs',
        props: {
            msg: String
        },
        components: {
            "pd-button": Button,
            "pd-uploadfileblock": Uploadfileblock
        },
        computed: {
            ...mapState("exportConfigStore", [
                "singlePpanelFiles",
                "fullPpanelFiles",
            ]),
            ...mapGetters('exportConfigStore', [
                "singlePpanelFiles",
                "fullPpanelFiles",
            ])
        },
        methods: {
            addSingle(typeId) {
                this.$store.commit('exportConfigStore/addSinglePPanelFIle',typeId);
            },
            addGlobal(typeId) {
                this.$store.commit('exportConfigStore/addGlobalPPanelFIle',typeId);
            },
            save(){
                this.$store.commit('exportConfigStore/persist');
            }
        },
        created() {
            this.$store.commit('exportConfigStore/loadFromDb');
        }
    }
</script>